import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function ServiceCompanies() {
  // specialist services
  this.getListCompanies = async () => new Promise((resolve, reject) => {
    axios.get('companies')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
  this.createGroup = async groupData => new Promise((resolve, reject) => {
    axios.post('companies/create', groupData)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.setActive = async id => new Promise((resolve, reject) => {
    axios.post(`companies/${id}/set-active`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.setPAPermission = async (id, bool) => new Promise((resolve, reject) => {
    axios.patch(`companies/${id}/set-pa`, {
      pa_enabled: bool,
    })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.ListCompanyMembers = async (id, params) => new Promise((resolve, reject) => {
    axios.get(`companies/members/${id}`, params)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.setGroupPercent = async (id, val) => new Promise((resolve, reject) => {
    axios.patch(`companies/percent/${id}`, { val })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.assignAdmin = async data => new Promise((resolve, reject) => {
    axios.post('companies/members/assign-admin', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  // admin services

  this.getListCompaniesAdmin = async params => new Promise((resolve, reject) => {
    axios.get('companies/admin/list', { params })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getCompaniesDetails = async id => new Promise((resolve, reject) => {
    axios.get(`companies/admin/${id}/details`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.generePagarme = async id => new Promise((resolve, reject) => {
    axios.post(`companies/admin/${id}/genere-pagarme`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.statusCompany = async (id, status) => new Promise((resolve, reject) => {
    axios.post(`companies/admin/${id}/status-company`, { status })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.uploadCnpj = async (id, data) => new Promise((resolve, reject) => {
    axios.post(`companies/admin/${id}/upload-cnpj`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.deleteCnpjDocument = async id => new Promise((resolve, reject) => {
    axios.delete(`companies/admin/${id}/delete-cnpj-document`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
